export const environment = {
  envName: "dev",
  production: true,
  googleMapsApiKey: 'AIzaSyDrxCURGOr6ViOwz8NHaiqPnpnWpyXaxD0',
  hereMapsApiKey: '4WwSOoB1GIsSf_bURZ4k519rEGLLKv-oAppB5Esk9ro',
  api: "http://cloudintercorpretail-dev.pe",
  apiLogin: "https://login.cloudintercorpretail-dev.pe",
  apiProducts: "https://business-irdgco-product.cloudintercorpretail-dev.pe",
  apiInventory: "https://inventory.cloudintercorpretail-dev.pe",
  apiAdditional: "https://additional.cloudintercorpretail-dev.pe",
  apiDelivery: "https://delivery.cloudintercorpretail-dev.pe",
  apiCustomer: "https://business-irdgco-dad-customer.cloudintercorpretail-dev.pe",
  apiCancellation: "https://cancellation.cloudintercorpretail-dev.pe",
  apiOrderPayment: "https://orderpayment.cloudintercorpretail-dev.pe",
  apiMessage: "https://messaging.cloudintercorpretail-dev.pe",
  apiAuthorization: "https://authorization.cloudintercorpretail-dev.pe",
  apiDispatchZone: "https://business-irdgco-zones.cloudintercorpretail-dev.pe",
  apiConfiguration: "https://configurations.cloudintercorpretail-dev.pe",
  apiRoutes: "https://routes.cloudintercorpretail-dev.pe",
  apiShipping: "https://shipping.cloudintercorpretail-dev.pe",
  apiIntegRoute: "https://integ-route.cloudintercorpretail-dev.pe",
  apiPicking: "https://picking.cloudintercorpretail-dev.pe",
  apiPickingReport: "https://picking-report.cloudintercorpretail-dev.pe",
  apiPickingReportv2: "https://picking-report-v2.cloudintercorpretail-dev.pe",
  apiEntity: "https://entity.cloudintercorpretail-dev.pe/",
  apiwithdraw: "https://withdraw.cloudintercorpretail-dev.pe",
  apiActionDispatch: "https://dispatch.cloudintercorpretail-dev.pe",
  apiReport: "https://report.cloudintercorpretail-dev.pe",
  apiPromotion: "https://promotion.cloudintercorpretail-dev.pe",
  apiUserReport: "https://user-report.cloudintercorpretail-dev.pe",
  apiQuotation:  "https://quotation.cloudintercorpretail-dev.pe",
  apiQuotationRead:  "https://business-irdgco-quotation-read.cloudintercorpretail-dev.pe",
  availableCredit: "https://quotation.cloudintercorpretail-dev.pe",
  apiMassiveStock: "https://conditions.cloudintercorpretail-dev.pe",
  apiLocation: "https://ms-location.cloudintercorpretail-dev.pe",
  apiMsQuotation: "https://ms-quotation.cloudintercorpretail-dev.pe",
  apiDashboard: "https://business-irdgco-dad-dashboard.cloudintercorpretail-dev.pe",
  apiRunDispatchReport: "https://user-report.cloudintercorpretail-dev.pe",
  apiRunPickingReport: "https://picking-report.cloudintercorpretail-dev.pe",
  apiBusinessEntity: "https://business-irdgco-entity.cloudintercorpretail-dev.pe",
  apiOrderPaymentRead:"https://business-irdgco-order-payment-read.cloudintercorpretail-dev.pe",
  apiBusinessPicking:'https://business-irdgco-picking.cloudintercorpretail-dev.pe',
  apiBusinessPickingRead:'https://business-irdgco-picking-read.cloudintercorpretail-dev.pe',
  apiBusinessDispatchRead:'https://business-irdgco-dispatch-read.cloudintercorpretail-dev.pe',
  apiBusinessLoginIntegration:'https://business-irdgco-login-integration.cloudintercorpretail-dev.pe',
  apiBusinessInventory: "https://business-irdgco-inventory-read.cloudintercorpretail-dev.pe",
  apiBusinessCapacity:'https://business-irdgco-capacity.cloudintercorpretail-dev.pe',
  apiBusinessDispatch: 'https://business-irdgco-dispatch.cloudintercorpretail-dev.pe',
  apiConfigRuleService:'https://business-irdgco-rules-service.cloudintercorpretail-dev.pe', //http://business-irdgco-rules-service.cloudintercorpretail-dev.pe
  apiBusinessCustomerIntegration: 'https://business-irdgco-customer-integration.cloudintercorpretail-dev.pe',
  apiCentralizedStockConfiguration: "https://centralized-stock-configuration.cloudintercorpretail-dev.pe",
  apiBusinessCentralizedStock: "https://centralized-stock-read.cloudintercorpretail-dev.pe",
  webChatUrl: "https://business-irdgco-chat-view.cloudintercorpretail-dev.pe/chat/web-chat",
  apiBusinessMultimedia: "https://business-irdgco-multimedia.cloudintercorpretail-dev.pe",
  apiBusinessMaintenanceLogistic: "https://business-irdgco-maintenance-logistic.cloudintercorpretail-dev.pe",
  apiBusinessLogistic:'https://business-irdgco-logistic.cloudintercorpretail-dev.pe',
  apiExternalIPapi: 'https://ipapi.co',
  azure: {
    apiAzureDevops: 'https://dev.azure.com',
    organization: 'e2eInretail',
    project: 'Copernico',
    team: 'Entre Llaves',
    summaryWorkItemFields: 'System.Id,System.Title,System.AssignedTo,System.State,System.Tags,Custom.Supp_Cia,Custom.Supp_Email',
    token: '4pTiYJdsstUiMAqV5vp6qAAWdu8BGgFlXTkveJvpSPUv9D5AoMA1JQQJ99CJACAAAAAYcEugAAASAZDOl1Aa'
  },
  appname: "inretail",
  sessionAuth: "inretail-auth",
  sessionData: "inretail-data",
  sessionMultiData: "multisession-data",
  settingPicking: 'SETTING_ENTITY',
  entityPicking: 'ENTITY_PICKING',
  redirectUriMsal: 'https://cloudintercorpretail-dev.pe',
  clientIdMsal: '1c2a6efc-3c78-45a3-831d-bb60456afd8b',
  authorityMsal: 'https://login.microsoftonline.com/5daabe65-ff53-4336-a448-2f61ecf0b059',
  userIP: 'User-IP',
  useCentralizedStock: 'use-centralized-stock',
  useCentralizedStockEntity: 'use-centralized-stock-entity',
  config_enable_login: {
    basic_user: 'configuration-all-x65jl7q1cr0cs3qrp6loofmxexdkm5j9',
    basic_pass: 'uwqxeiyo3tdjh8pfvf8ibyk7b2z0n3s7',
    config_cod: 'ENABLE_DAD_LOGIN',
  },
  config_enable_repactcha: {
    config_reCAPTCHA: 'ENABLE_RECAPTCHA',
    googlereCAPTCHA: "_grecaptcha",
    reCAPTCHA: "reCAPTCHA",
    reCAPTCHAKey: "reCAPTCHAKey",
    enabledreCAPTCHA: "enabledreCAPTCHA"
  }
};
